/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Button from '@common_button';
import TextField from '@common_forms/TextField';
import Typography from '@common_typography';
import { useTranslation } from 'next-i18next';
// import Alert from '@common_alert';
import cx from 'classnames';
import React from 'react';
import gqlService from '@core_modules/checkout/services/graphql';
import Dialog from '@common_dialog';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectCheckoutState, setCheckoutData, setErrorState, setSelectedStore,
    setSelectedData,
} from '@core_modules/checkout/redux/checkoutSlice';
import { COLORS } from '@theme_vars';
import UrbanIcon from '@core_modules/theme/plugins/urbanicon';
import Backdrop from '@common/Backdrop';
import InfoIcon from '@heroicons/react/24/solid/InformationCircleIcon';

const ModalSelectStore = ({
    open, setOpen,
    listStores = [],
}) => {
    const { t } = useTranslation(['common', 'checkout', 'validate']);
    const [stores, setStores] = React.useState(listStores);
    const [search, setSearch] = React.useState('');
    const [setPickupStore] = gqlService.setPickupStore();
    const [setBillingAddressByInput] = gqlService.setBillingAddressOnCartByInput();

    const dispatch = useDispatch();
    const checkout = useSelector(selectCheckoutState);

    const { billing } = checkout.selected;

    const [selected, setSelected] = React.useState({
        key: null,
        item: null,
    });
    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = React.useState(false);

    const handleSave = async () => {
        await setLoading(true);
        if (Object.keys(checkout.pickupInformation).length > 0) {
            await setPickupStore({
                variables: {
                    cart_id: checkout.data.cart.id,
                    code: selected.item.code,
                    extension_attributes: checkout.pickupInformation,
                    store_address: {
                        city: selected.item.city,
                        country_code: selected.item.country_id,
                        name: selected.item.name,
                        postcode: selected.item.postcode,
                        region: selected.item.region,
                        street: [selected.item.street],
                        telephone: selected.item.telephone,
                    },
                },
            }).then(async (res) => {
                const paymentMethod = await res.data.setPickupStore.available_payment_methods.map((method) => ({
                    ...method,
                    label: method.title,
                    value: method.code,
                    image: null,
                }));
                await dispatch(setCheckoutData({
                    cart: {
                        ...checkout.data.cart,
                        ...res.data.setPickupStore,
                    },
                    paymentMethod,
                }));

                await setBillingAddressByInput({
                    variables: {
                        cartId: checkout.data.cart.id,
                        same_as_shipping: false,
                        firstname: billing.firstname,
                        lastname: billing.lastname,
                        telephone: billing.telephone,
                        region: billing.region.code,
                        city: billing.city,
                        postcode: billing.postcode,
                        street: billing.street[0],
                        countryCode: billing.country.code,
                    },
                })
                    .then(async (resBilling) => {
                        const billingAddress = resBilling.data.setBillingAddressOnCart.cart.billing_address;
                        dispatch(
                            setSelectedData({
                                billing: {
                                    firstname: billingAddress.firstname,
                                    lastname: billingAddress.lastname,
                                    city: billingAddress.city,
                                    region: billingAddress.region,
                                    country: billingAddress.country,
                                    postcode: billingAddress.postcode,
                                    telephone: billingAddress.telephone,
                                    street: billingAddress.street,
                                },
                            }),
                        );
                        dispatch(setSelectedStore({
                            ...selected.item,
                        }));
                        dispatch(setErrorState({
                            selectStore: false,
                            pickupInformation: false,
                        }));
                        await setLoading(false);
                        setOpen();
                    })
                    .catch((err) => {
                        window.toastMessage({
                            open: true,
                            variant: 'error',
                            text: err.message.split(':')[1] || t('checkout:message:serverError'),
                        });
                        setLoading(false);
                    });
            }).catch((err) => {
                window.toastMessage({
                    open: true,
                    variant: 'error',
                    text: err.message.split(':')[1] || t('checkout:message:serverError'),
                });
                setLoading(false);
            });
        } else {
            dispatch(setSelectedStore({
                ...selected.item,
            }));
            dispatch(setErrorState({
                selectStore: false,
                pickupInformation: true,
            }));

            await setLoading(false);
            setOpen();
        }
    };

    const handleSelect = async (key, item) => {
        setSelected({
            key,
            item,
        });
        setLoading(true);
    };

    const getStyle = (key, index) => {
        let classname;
        // eslint-disable-next-line max-len
        const styleCard = 'w-full pt-4 pb-8 px-4 flex flex-col items-left justify-between border-b border-neutral-100 rounded-none last-of-type:border-b-0';
        const styleCardActive = '!border-primary';
        const styleCardLast = '';
        if (selected.key && selected.key === key) {
            classname = cx(styleCard, styleCardActive);
        } else if (Object.keys(checkout.selectStore).length > 0 && !selected.key) {
            if (key === checkout.selectStore.code) {
                classname = cx(styleCard, styleCardActive);
            } else if (index === listStores.length - 1) {
                classname = cx(styleCard, styleCardLast);
            } else {
                classname = styleCard;
            }
        } else if (index === listStores.length - 1 && key === selected.key) {
            classname = cx(styleCard, styleCardActive, styleCardLast);
        } else if (index === listStores.length - 1) {
            classname = cx(styleCard, styleCardLast);
        } else {
            classname = styleCard;
        }

        return classname;
    };

    const handleSearch = (event) => {
        const { value } = event.target;
        const newItem = listStores.filter(
            ({
                name, region, city, street,
            }) => name.toLowerCase().search(value.toLowerCase()) > -1 || region.toLowerCase().search(value.toLowerCase()) > -1
                || city.toLowerCase().search(value.toLowerCase()) > -1 || street.toLowerCase().search(value.toLowerCase()) > -1,
        );
        setSearch(value);
        setStores(newItem);
    };

    const handleOpeningHours = (operation_time) => (
        <div className="opening_hours">
            {operation_time.map((time) => (
                <li className="list-none text-neutral-150 uppercase">
                    {`${time.day}: ${time.open_at} - ${time.close_at}`}
                </li>
            ))}
        </div>
    );

    React.useEffect(() => {
        if (selected?.item) {
            handleSave();
        }
    }, [selected]);

    React.useEffect(() => {
        setStores(listStores);
    }, [listStores]);

    React.useEffect(() => {
        if (loading) {
            window.backdropLoader(true);
        }
        window.backdropLoader(false);
    }, [loading]);

    return (
        <>
            <div className="z-backdrop-loader">
                <Backdrop open={loading} />
            </div>
            <Dialog
                open={open}
                closeOnBackdrop
                onClose={() => setOpen()}
                onClickCloseTitle={() => setOpen()}
                title={t('checkout:pickupInformation:selectStoreLocation')}
                useCloseTitleButton
                classTitle="!text-2xl !font-bold text-primary !px-5 !leading-6"
                classWrapperTitle="!rounded-none !pb-[11px]"
                classContent="!rounded-none !px-5"
                content={(
                    <>
                        <Typography variant="p-2" className="!text-[15px] !leading-[22px] !text-neutral-500 mb-5">
                            {(t('checkout:pickupInformation:storeLocationNote'))}
                        </Typography>
                        <div className="flex flex-col">
                            <div className="flex flex-col gap-4 relative h-full">
                                <TextField
                                    label={t('checkout:pickupInformation:searchStore')}
                                    value={search}
                                    onChange={handleSearch}
                                    className="w-full"
                                    placeholder={t('checkout:pickupInformation:searchStore')}
                                    classNameLabelText="!font-normal !text-primary"
                                />
                                <div className="w-full border-b border-secondary-600 mt-2" />
                                <div className="stores_list-wrapper flex flex-col gap-4 relative h-full max-h-[50vh] overflow-y-auto">
                                    {
                                        stores.length > 0
                                            ? stores.map((item, index) => {
                                                const isContainUnavailableSku = item.skus_not_available.length > 0;
                                                const stringUnavailableSkus = isContainUnavailableSku
                                                    ? item.skus_not_available.join(', ')
                                                    : null;
                                                const skuUnavailableLabel = item.skus_not_available.length > 1
                                                    ? t('checkout:pickupInformation:multipleProductsUnavailable',
                                                        { unavailableSkus: stringUnavailableSkus })
                                                    : t('checkout:pickupInformation:productUnavailable',
                                                        { unavailableSkus: stringUnavailableSkus });

                                                return (
                                                    <div
                                                        key={item.code}
                                                        className={getStyle(item.code, index)}
                                                    >
                                                        <div
                                                            // onClick={() => handleSelect(item.code, item)}
                                                            className={cx(
                                                                'flex !flex-row flex-nowrap gap-x-3',
                                                            )}
                                                        >
                                                            <div className="store_info flex flex-col basis-4/5">
                                                                <Typography variant="bd-2" type="bold" className="!text-[15px] mb-1">
                                                                    {item.name}
                                                                </Typography>
                                                                <Typography className="!text-neutral-500 !text-[13px] !tracking-[.33px]">
                                                                    {item.street}
                                                                    <br />
                                                                    {item.city}
                                                                    <br />
                                                                    {item.region}
                                                                    {', '}
                                                                    {item.country}
                                                                    {', '}
                                                                    {item.postcode}
                                                                    <br />
                                                                    {item.telephone}
                                                                    <br />
                                                                    {item?.opening_hours.length > 0 ? (
                                                                        <div className="flex flex-row gap-x-3">
                                                                            <div>
                                                                                <UrbanIcon
                                                                                    iconContent='"\e946"'
                                                                                    fontSize={13}
                                                                                    width={13}
                                                                                    height={13}
                                                                                    className="!text-neutral-150 block mt-[6px]"
                                                                                />
                                                                            </div>
                                                                            {handleOpeningHours(item.opening_hours)}
                                                                        </div>
                                                                    ) : null}

                                                                </Typography>
                                                            </div>
                                                            <Button
                                                                variant="outlined"
                                                                className={cx(
                                                                    'h-[40px] swift-action-apply bg-neutral-black',
                                                                    'disabled:bg-neutral-white disabled:!text-neutral-400',
                                                                    'basis-auto mr-2.5 disabled:border disabled:border-neutral-400',
                                                                )}
                                                                disabled={isContainUnavailableSku || selected.key === item.code}
                                                                onClick={() => { handleSelect(item.code, item); }}
                                                            >
                                                                <Typography
                                                                    color={cx(
                                                                        isContainUnavailableSku || selected.key === item.code ? 'text-neutral-400'
                                                                            : 'text-neutral-black group-hover:text-neutral-white',
                                                                    )}
                                                                    className="uppercase leading-normal text-sm text-center !font-bold"
                                                                >
                                                                    {selected.key === item.code
                                                                        ? t('checkout:selected') : t('checkout:select')}
                                                                </Typography>
                                                            </Button>
                                                        </div>
                                                        {isContainUnavailableSku && (
                                                            <div className="flex gap-1 items-start mt-2">
                                                                <InfoIcon className="w-[16px] min-w-[16px] pt-[2px] text-red-600" />
                                                                <Typography
                                                                    color="text-red-600"
                                                                    className="!text-[13px] !leading-5"
                                                                >
                                                                    {skuUnavailableLabel}
                                                                </Typography>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })
                                            : (
                                                <div className="my-5 mx-auto">
                                                    <div className="flex justify-center flex-col max-w-[320px]">

                                                        <UrbanIcon
                                                            fontSize={100}
                                                            width={100}
                                                            height={100}
                                                            iconContent='"\e615"'
                                                            className="!text-neutral-100 self-center"
                                                        />
                                                        <Typography
                                                            variant="p-2"
                                                            className="text-center !text-neutral-500 leading-[22px] tracking-[.33px] !text-[15px]"
                                                        >
                                                            {t('checkout:storesNotFound')}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            )
                                    }
                                </div>
                                <div className="w-full border-b border-secondary-600 mt-1" />
                            </div>
                            {/* <Button
                            loading={loading}
                            className="w-full"
                            classNameText="justify-center"
                            onClick={handleSave}
                            disabled={!stores || stores.length === 0}
                        >
                            {t('common:button:save')}
                        </Button> */}
                        </div>
                        <style jsx>
                            {`
                        .stores_list-wrapper::-webkit-scrollbar-track {
                            background: 0 0;
                        }
                        .stores_list-wrapper::-webkit-scrollbar-thumb {
                            background-color: ${COLORS.secondary[600]};
                            border-radius: 8px;
                            border: 1px solid transparent;
                        }
                        .stores_list-wrapper::-webkit-scrollbar {
                            width: 8px;
                        }
                        .stores_list-wrapper {
                            overflow-x: hidden;
                            scrollbar-width: thin;
                            scrollbar-color: ${COLORS.secondary[600]} transparent;
                        }
                    `}
                        </style>
                    </>
                )}
            />
        </>
    );
};

export default ModalSelectStore;
